import s from './ResponseDebugger.module.scss';

type Props = {
  field: {
    type: string;
    options: { key: string; label: string }[];
  };
  value: unknown;
};

const Value: React.FC<Props> = ({ field, value }) => {
  if (value === null || value === undefined) {
    return <div>null</div>;
  }

  if (
    field.type === 'single-select'
    || field.type === 'selection'
    || field.type === 'multi-select'
  ) {
    const definitelyArray = Array.isArray(value) ? value : [value];
    return (
      <>
        {definitelyArray.map((val, index) => {
          const thisOption = field.options.find((option) => option.key === val);
          return (
            <pre className={s.value} key={index}>
              {thisOption ? thisOption.label : 'Unknown option'} ({JSON.stringify(val, null, 2)})
            </pre>
          );
        })}
      </>
    );
  }

  return (
    <pre className={s.value}>{JSON.stringify(value, null, 2)}</pre>
  );
};

export default Value;